const PAGE_SIZE = 10;

function ordinal(n) {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

class RacingResultsTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.tableBody = self.elem.querySelector("[data-racing-results-table-body]");
        self.apiUrl = self.elem.dataset.apiUrl;
        self.allResults = [];
        self.currentPage = 0;
        self.loadMoreBtn = null;
    }

    async init() {
        let self = this;

        if (!self.apiUrl) {
            console.error("No API URL defined on table element.");
            return;
        }

        try {
            const response = await fetch(self.apiUrl);

            if (!response.ok) throw new Error(`API request failed: ${response.status}`);
            let data = await response.json();

            self.allResults = (data.data || []).sort((a, b) => {
                const dateA = new Date(a.raceDate);
                const dateB = new Date(b.raceDate);
                return dateB - dateA;
            });

            self.renderPage();
        } catch (err) {
            console.error("Error fetching racing results:", err);
        }
    }

    renderPage() {
        let self = this;

        if (!self.allResults.length) {
            self.populateEmpty();
            return;
        }

        // Clear placeholder row on first render
        if (self.currentPage === 0) self.tableBody.textContent = "";

        const start = self.currentPage * PAGE_SIZE;
        const slice = self.allResults.slice(start, start + PAGE_SIZE);

        slice.forEach(result => self.appendRow(result));

        self.currentPage++;

        self.updateLoadMoreBtn();
    }

    populateEmpty() {
        let self = this;

        self.tableBody.textContent = "";

        const row = document.createElement("tr");
        const cell = document.createElement("td");
        cell.colSpan = 7;
        cell.classList.add("text-center");
        cell.textContent = "No results available";
        row.appendChild(cell);
        self.tableBody.appendChild(row);
    }

    appendRow(result) {
        let self = this;

        const row = document.createElement("tr");

        const raceDate = new Date(result.raceDate);
        const formattedDate = `${String(raceDate.getDate()).padStart(2, '0')}.${String(raceDate.getMonth() + 1).padStart(2, '0')}.${raceDate.getFullYear()}`;

        const columns = [
            { value: formattedDate },
            { value: result.animalName, classes: ['text-uppercase', 'fw-bold'] },
            { value: result.raceCourse },
            { value: result.position != null ? ordinal(result.position) : '' },
            { value: result.saleName, classes: ['col-wrap'] },
            { value: result.vendorName, classes: ['col-wrap'] },
            { value: result.purchaserName, classes: ['col-wrap'] },
        ];

        columns.forEach(({ value, classes }) => {
            const cell = document.createElement("td");
            cell.textContent = value ?? "";
            if (classes) cell.classList.add(...classes);
            row.appendChild(cell);
        });

        self.tableBody.appendChild(row);
    }

    updateLoadMoreBtn() {
        let self = this;

        const hasMore = self.currentPage * PAGE_SIZE < self.allResults.length;

        if (hasMore && !self.loadMoreBtn) {
            self.loadMoreBtn = document.createElement("div");
            self.loadMoreBtn.classList.add("text-center", "mt-3");

            const btn = document.createElement("button");
            btn.type = "button";
            btn.classList.add("btn", "btn-primary");
            btn.textContent = "Load more";
            btn.addEventListener("click", () => self.renderPage());

            self.loadMoreBtn.appendChild(btn);
            self.elem.after(self.loadMoreBtn);
        } else if (!hasMore && self.loadMoreBtn) {
            self.loadMoreBtn.remove();
            self.loadMoreBtn = null;
        }
    }
}

export default RacingResultsTable;
